<template>
  <span v-if="data.field.sortable">
    <img v-if="sortBy !== data.field.key" src="@/assets/sort-default.svg" style="height: 18px" />
    <img v-else-if="sortDesc" src="@/assets/sort-desc.svg" style="height: 18px" />
    <img v-else src="@/assets/sort-asc.svg" style="height: 18px" />
  </span>
</template>

<script>
export default {
  props: {
    data: Object,
    sortBy: String,
    sortDesc: Boolean
  },
  data() {
    return {};
  }
};
</script>
